import React from 'react';
import { Link } from 'react-router-dom';
import logo from "../img/carbon.png";
import youtube from "../img/youtube.svg";
import facebook from "../img/facebook.svg";
import instagram from "../img/instagram.svg";
import tiktok from "../img/tiktok.svg";

export default function Footer() {
  return (
    <footer className="bg-dark text-light text-center pt-5 pb-3 mt-5">
      <div className="container">
        <div className="row">

          {/* Brand */}
          <div className="col-md-4 mb-4">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="Logo" height="150" />
            </Link>
            <p>Enjoy the journey!</p>
          </div>

          {/* Links */}
          <div className="col-md-4 mb-4 mt-5">
            <h2>Link</h2>
            <ul className="list-unstyled">
              <li>
                <Link to="/usluge/pojasevi" className="text-light text-decoration-none">
                  Pojasevi
                </Link>
              </li>
              <li>
                <Link to="/usluge/custom-dizajn-volana" className="text-light text-decoration-none">
                  Volani
                </Link>
              </li>
              <li>
                <Link to="/galerija" className="text-light text-decoration-none">
                  Galerija
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className="col-md-4 mb-4 mt-5">
            <h5>Prati nas</h5>
            <div>
              <a
                className="btn btn-facebook mx-2"
                href="https://www.facebook.com/p/CarbonCRO-61572170053643/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebook} alt="Facebook" height="25" />
              </a>
              <a
                className="btn btn-instagram-nav mx-2"
                href="https://www.instagram.com/carbon.cro/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="Instagram" height="25" />
              </a>
              <a
                className="btn btn-tiktok mx-2"
                href="https://www.tiktok.com/@carbon.cro"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={tiktok} alt="TikTok" height="25" />
              </a>
              <a
                className="btn btn-youtube-nav mx-2"
                href="https://www.youtube.com/@CarbonCro"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={youtube} alt="YouTube" height="25" />
              </a>
            </div>
          </div>

        </div>

        <hr className="border-secondary" />

        <div className="text-center">
          <small>© 2026 Carbon Cro. Sva prava pridržana. Development by LineCode Agency.</small>
        </div>
      </div>
    </footer>
  );
}